import { render, staticRenderFns } from "./cpf.vue?vue&type=template&id=0ec98ef1"
import script from "./cpf.ts?vue&type=script&lang=js&external"
export * from "./cpf.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ec98ef1')) {
      api.createRecord('0ec98ef1', component.options)
    } else {
      api.reload('0ec98ef1', component.options)
    }
    module.hot.accept("./cpf.vue?vue&type=template&id=0ec98ef1", function () {
      api.rerender('0ec98ef1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/child/form/cpf.vue"
export default component.exports